module.exports = __webpack_public_path__ + "static/media/high-rise-building.f437be98.jpg";